"use strict";
import { Children, cloneElement, isValidElement, memo } from "react";
import { sendAnalyticsEvent } from ".";
import { Trace, TraceContext } from "./Trace";
export const TraceEvent = memo((props) => {
  const { shouldLogImpression, name, properties, events, children, ...traceProps } = props;
  return <Trace {...traceProps}>
      <TraceContext.Consumer>
        {(traceContext) => Children.map(children, (child) => {
    if (!isValidElement(child)) {
      return child;
    }
    return cloneElement(
      child,
      getEventHandlers(child, traceContext, events, name, properties, shouldLogImpression)
    );
  })}
      </TraceContext.Consumer>
    </Trace>;
});
TraceEvent.displayName = "TraceEvent";
function getEventHandlers(child, traceContext, events, name, properties, shouldLogImpression = true) {
  const eventHandlers = {};
  for (const event of events) {
    eventHandlers[event] = (eventHandlerArgs) => {
      const args = Array.isArray(eventHandlerArgs) ? eventHandlerArgs : [eventHandlerArgs];
      child.props[event]?.apply(child, args);
      if (shouldLogImpression) {
        sendAnalyticsEvent(name, { ...traceContext, ...properties, action: event });
      }
    };
  }
  return eventHandlers;
}
